// $('body').on('click','.AddToCart',function(e){
  //   e.preventDefault();
  //   var btn = $(this);
  //   var form = $(this).closest('form');
  //   btn.attr('disabled', 'disabled');
  //   btn.text('You have added successfully');
  //   form.find('.error').remove();
  //   console.log('form-----'+form.serialize());
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: form.serialize(),
  //     dataType: 'json',
  //     error: function(jqXHR, textStatus, errorThrown){
  //       var response = $.parseJSON(jqXHR.responseText);
  //       form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
  //       btn.text('ADD TO CART');
  //       btn.removeAttr('disabled');
  //     }
  //   }).done(function( data ) {
  //     $('div[data-popup="cart-success"] h3').text(data.title);
  //     $('div[data-popup="cart-success"]').addClass('popup-active');
  //     $('.overlay').addClass('popup-active');
  //     btn.text('Add to Cart');
  //     btn.removeAttr('disabled');
  //     $.getJSON('/cart.js', function(cart){
  //       refreshCart(cart);
  //     });
  //   });
  // });
//   $('body').on('click','.AddToCart',function(e){
//     e.preventDefault();
//     var btn = $(this);
//     var form = $(this).closest('form');
//     console.log('form-----'+form.serialize());
    
//       $('div[data-popup="cart-success"] h3').text('Product Title');
//       $('div[data-popup="cart-success"]').addClass('popup-active');
//       $('.overlay').addClass('popup-active');
    
//   });
  $("body").on('click', ".popup-closer,.keep_shop", function(e){
    e.preventDefault();
    var $parents = $('.popup-active').attr('data-popup');
    $(this).closest(".cs-popup").removeClass("popup-active");
    $('.overlay').removeClass("popup-active");
     $('.poup_position').removeClass("popup-active");
    $("body").removeClass("overflow_hidden");
  });
  $("body").on('click', ".overlay", function(e){
      e.preventDefault();
      var $parents = $('.popup-active').attr('data-popup');
      $('.cs-popup').removeClass('popup-active');
      $('.overlay').removeClass("popup-active");
      $('body').removeClass("popup-active");
    $('.poup_position').removeClass("popup-active");
    $("body").removeClass("overflow_hidden");
    });